import { curry } from 'ramda'
import { createSelector } from 'reselect'

import { Features, FeatureState, LoadingState } from '../models'

const selectFeaturesState = (state): FeatureState => state && state.features

const areFlagsLoaded = (state: FeatureState) =>
  state && (state.loading === LoadingState.SUCCESS || state.loading === LoadingState.ERROR)

export const selectAreFlagsLoaded = createSelector(selectFeaturesState, areFlagsLoaded)

export const isFeatureEnabled = curry((feature: Features, state: FeatureState) => {
  const featureState = selectFeaturesState(state)

  return !!featureState && featureState.features[feature]
})
